module.exports = __webpack_public_path__ + "static/media/error.0ec262d5.svg";